import AuthContactPanel from 'components/common/AuthContactPanel';
import React from 'react';

const CompanyLandingRightPanel = () => {
  return (
    <>
      <AuthContactPanel />
    </>
  );
};

export default CompanyLandingRightPanel;
